import { render, staticRenderFns } from "./ProjectZZPers.vue?vue&type=template&id=1419fb94"
import script from "./ProjectZZPers.vue?vue&type=script&lang=js"
export * from "./ProjectZZPers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports